(function () {
  var PAIRINGS = [
    {
      removeSelector: '.get-even-serum-foundation .remove',
      partnerTitle: 'GET EVEN MOISTURIZING PRIMER',
      variantId: 40191015911502
    },
    {
      removeSelector: '.get-even-primer .remove',
      partnerTitle: 'GET EVEN FOUNDATION',
      variantId: 40191015911502
    },
    {
      removeSelector: '.matte-up-balancing-primer .remove',
      partnerTitle: 'MATTE UP FOUNDATION',
      variantId: 40191037571150
    },
    {
      removeSelector: '.matte-up-foundation .remove',
      partnerTitle: 'MATTE UP BALANCING PRIMER',
      variantId: 40191037571150
    },
    {
      removeSelector: '.calm-on-foundation .remove',
      partnerTitle: 'CALM ON HYDRATING GEL PRIMER',
      variantId: 40191039438926
    },
    {
      removeSelector: '.calm-on-hydrating-gel-primer .remove',
      partnerTitle: 'CALM ON FOUNDATION',
      variantId: 40191039438926
    },
    {
      removeSelector: '.over-dew-primer .remove',
      partnerTitle: 'DECREASE  FOUNDATION',
      variantId: 40191042715726
    },
    {
      removeSelector: '.decrease-foundation .remove',
      partnerTitle: 'OVER DEW PLUMPING PRIMER',
      variantId: 40191042715726
    }
  ];

  function wrapLastWordInTitles() {
    document.querySelectorAll('.cart-item .title').forEach(function (heading) {
      if (heading.querySelector('span')) return;
      var html = heading.innerHTML;
      var wordArray = html.split(/\s+/);
      if (wordArray.length < 2) return;
      var lastWord = wordArray.pop();
      var firstPart = wordArray.join(' ');
      heading.innerHTML = firstPart + ' <span>' + lastWord + '</span>';
    });
  }

  function cartHasTitle(title) {
    var titles = document.querySelectorAll('.cart-item .title');
    for (var i = 0; i < titles.length; i++) {
      if ((titles[i].textContent || '').trim() === title) {
        return true;
      }
    }
    return false;
  }

  function refreshCartUi() {
    if (typeof window.refreshCart === 'function') {
      window.refreshCart();
    } else if (window.TBMiniCart && typeof window.TBMiniCart.refresh === 'function') {
      window.TBMiniCart.refresh();
    }
  }

  function removeVariant(variantId) {
    var updates = {};
    updates[variantId] = 0;
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (res) {
        return res.json();
      })
      .then(function () {
        refreshCartUi();
      })
      .catch(function (err) {
        console.error(err);
      });
  }

  function matchesRemoveSelector(el, selector) {
    // selector like ".get-even-serum-foundation .remove"
    var parts = selector.trim().split(/\s+/);
    if (parts.length < 2) return el.matches(selector);
    var parentSel = parts[0];
    var childSel = parts.slice(1).join(' ');
    if (!el.matches(childSel) && !el.closest(childSel)) return false;
    var target = el.matches(childSel) ? el : el.closest(childSel);
    return !!(target && target.closest(parentSel));
  }

  function onRemoveClick(e) {
    var target = e.target.closest('.remove');
    if (!target) return;

    for (var i = 0; i < PAIRINGS.length; i++) {
      var pairing = PAIRINGS[i];
      if (!matchesRemoveSelector(target, pairing.removeSelector)) continue;

      (function (partnerTitle, variantId) {
        setTimeout(function () {
          if (!cartHasTitle(partnerTitle)) {
            removeVariant(variantId);
          }
        }, 1200);
      })(pairing.partnerTitle, pairing.variantId);
      break;
    }
  }

  function onCartOpenClick(e) {
    var btn = e.target.closest('#cart-open-button');
    if (!btn) return;
    e.preventDefault();
    if (typeof window.refreshCart === 'function') {
      window.refreshCart(true);
    }
    if (typeof window.tbOpenCartSidebar === 'function') {
      window.tbOpenCartSidebar();
    } else {
      var sidebar = document.getElementById('site-cart-sidebar');
      if (sidebar && typeof sidebar.show === 'function') sidebar.show();
    }
  }

  function init() {
    wrapLastWordInTitles();
    document.addEventListener('click', onRemoveClick);
    document.addEventListener('click', onCartOpenClick);
    document.addEventListener('tb:cart:refreshed', wrapLastWordInTitles);
    document.addEventListener('cart:updated', wrapLastWordInTitles);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
